
import Schedule from '@/pages/Schedule';
import ProtectedRoute from '@/components/auth/ProtectedRoute';

export default function SchedulePage() {
  return (
    <ProtectedRoute requiredRole="staff">
      <Schedule />
    </ProtectedRoute>
  );
}
